<template>
  <div class="properties-list">
    <section class="properties-header">
      <div class="container">
        <h2>{{ pageTitle }}</h2>
      </div>
    </section>
    <div class="properties-content">
      <section class="properties-filter">
        <div class="container">
          <label> Buscar empreendimentos </label>
          <div class="search">
            <img src="~@/assets/icons/icon-search.svg" alt="" />
            <input
              type="text"
              placeholder="Buscar"
              v-model="searchText"
              @change="searchChange()"
            />
            <a @click="searchChange()" class="button-primary"
              ><img src="~@/assets/icons/icon-search-white.svg" alt=""
            /></a>
          </div>
          <label> Estado </label>
          <select
            class="select"
            v-model="stateSelected"
            v-on:change="stateChange"
          >
            <option v-for="item in this.states" :value="item" :key="item.id">
              {{
                item.attributes.name == "Todos" ? "Todos" : item.attributes.name
              }}
            </option>
          </select>
          <label> Cidade </label>
          <select
            class="select"
            v-model="citySelected"
            v-on:change="cityChange"
          >
            <option v-for="item in this.cities" :value="item" :key="item.id">
              {{
                item.attributes.name == "Todos" ? "Todas" : item.attributes.name
              }}
            </option>
          </select>
          <label> Tipo </label>
          <select
            class="select"
            v-model="propertyTypeSelected"
            v-on:change="propertyTypeChange"
          >
            <option
              v-for="item in this.propertyTypes"
              :value="item"
              :key="item.id"
              >{{ item.attributes.name }}</option
            >
          </select>
        </div>
      </section>
      <div v-if="loader" class="loader">
        <img src="~@/assets/loader.gif" alt="" />
        <p>Carregando empreendimentos...</p>
      </div>
      <div v-if="!loader && empty" class="empty">
        <img src="~@/assets/image-empty.svg" alt="" />
        <h3>Oops!</h3>
        <p>
          Não foi possivel encontrar o que está procurando, filtre novamente e
          encontre o empreendimento ideal.
        </p>
      </div>
      <section v-if="!loader" class="properties-section">
        <div class="container container-properties">
          <div
            class="box-properties"
            v-for="item in this.properties"
            :value="item.id"
            :key="item.id"
          >
            <router-link
              :to="{
                name: 'Properties',
                params: { slug: item.attributes.slug, id: item.id }
              }"
              exact
            >
              <img
                v-if="item.attributes.banner"
                class="properties-image"
                alt=""
                :src="item.attributes.banner"
              />

              <div class="properties-content">
                <p class="tag">{{ item.attributes.building_status.name }}</p>
                <div>
                  <router-link
                    :to="{
                      name: 'Properties',
                      params: { slug: item.attributes.slug, id: item.id }
                    }"
                    exact
                  >
                    <img class="logo" alt="" :src="item.attributes.logo" />
                  </router-link>

                  <router-link
                    :to="{
                      name: 'Properties',
                      params: { slug: item.attributes.slug, id: item.id }
                    }"
                    exact
                  >
                    <h3>{{ item.attributes.name }}</h3>
                  </router-link>

                  <router-link
                    :to="{
                      name: 'Properties',
                      params: { slug: item.attributes.slug, id: item.id }
                    }"
                    exact
                  >
                    <p class="locale">{{ getAddress(item.attributes) }}</p>
                  </router-link>

                  <p class="infos">
                    {{ buildingDetail(item.attributes) }}
                  </p>
                </div>
              </div>
            </router-link>
          </div>
        </div>
        <div class="view-more" v-if="renderViewMore">
          <a @click="viewMore()">Carregar mais</a>
        </div>
      </section>
    </div>
  </div>
</template>

<script>
import { buildingsService } from "@/services/buildings.service.js";
import { regionsService } from "@/services/regions.service";

export default {
  name: "PropertiesList",
  data() {
    return {
      loader: false,
      empty: false,
      firstValue: { id: "", attributes: { name: "Todos" } },
      properties: [],
      states: [],
      cities: [],
      prices: [],
      stateSelected: {},
      citySelected: {},
      priceSelected: "",
      sortType: "",
      propertyTypeSelected: "",
      searchText: undefined,
      currentPage: 1,
      perPage: 12,
      totalItems: 0,
      totalPages: 0
    };
  },

  computed: {
    renderViewMore() {
      return this.perPage < this.totalItems;
    },

    pageTitle() {
      let title = `${this.totalItems} Empreendimento(s)`;
      let selectedState = this.stateSelected?.attributes?.name;

      if (selectedState && selectedState !== "Todos") {
        title = `${title}  em: ${selectedState}`;
      }

      return title;
    },

    propertyTypes() {
      return [
        {
          id: "",
          attributes: { name: "Todos" }
        },
        {
          id: "apartment",
          attributes: { name: "Apartamento" }
        },
        {
          id: "house",
          attributes: { name: "Casa" }
        },
        {
          id: "room",
          attributes: { name: "Sala" }
        },
        {
          id: "shop",
          attributes: { name: "Loja" }
        },
        {
          id: "allotment",
          attributes: { name: "Loteamento" }
        }
      ];
    }
  },

  async mounted() {
    const state = this.$route.params.state;
    const city = this.$route.params.city;

    if (state != null && city != null) {
      this.retrieveValuesFromHome(state, city);
    } else {
      this.initialize();
      await this.getStates();
    }

    this.getProperties();
  },

  methods: {
    initialize() {
      this.states = [this.firstValue];
      this.cities = [this.firstValue];
      this.stateSelected = this.firstValue;
      this.citySelected = this.firstValue;
      this.propertyTypeSelected = this.firstValue;
    },

    viewMore() {
      if (this.perPage <= this.totalItems) {
        this.perPage = this.perPage + 12;
        this.getProperties();
      }
    },

    buildingDetail(property) {
      let detail = [];

      if (property.area && property.area !== "null") {
        detail.push(`${property.area}m²`);
      }

      if (property.bedrooms && property.area !== "null") {
        let roomLabel = property.bedrooms === 1 ? "quarto" : "quartos";
        detail.push(`${property.bedrooms} ${roomLabel}`);
      }

      if (!detail.length) {
        detail.push("Não informado");
      }

      return detail.join(" - ");
    },

    getAddress(property) {
      const address = property.address;

      return address != null && address != "undefined" ? address : "--";
    },

    retrieveValuesFromHome(state, city) {
      this.states = this.$route.params.states;
      this.cities = this.$route.params.cities;
      this.stateSelected = state;
      this.citySelected = city;
      this.propertyTypeSelected = this.firstValue;
    },

    async getProperties() {
      this.loader = true;
      try {
        const params = {
          search: this.searchText,
          state_id: this.stateSelected.id,
          city_id: this.citySelected.id,
          price: this.sortType,
          property_type: this.propertyTypeSelected.id,
          page: this.currentPage,
          items: this.perPage,
          is_visible: true
        };
        const properties = await buildingsService.listBuildings(params);
        this.totalItems = properties.data.meta.count;
        this.totalPages = properties.data.meta.pages;
        this.currentPage = properties.data.meta.page;
        this.properties = properties.data.data;
        this.loader = false;
        if (properties.data.data.length < 1) {
          this.empty = true;
        } else {
          this.empty = false;
        }
      } catch (error) {
        this.loader = false;
        console.log("Ocorreu um erro inesperado.");
      }
    },

    async getStates() {
      this.loader = true;
      try {
        const response = await regionsService.retrieveStates();
        this.states = [].concat.apply(this.states, response.data.data);
        this.loader = false;
        if (response.data.data.length < 1) {
          this.empty = true;
        } else {
          this.empty = false;
        }
      } catch {
        console.log("Ocorreu um erro inesperado.");
      }
    },

    async getCities(id) {
      this.loader = true;

      if (!id) {
        this.cities = [this.firstValue];

        this.empty = true;
        this.loader = false;

        return;
      }

      try {
        const params = { stateId: id };
        const response = await regionsService.retrieveRegions(params);
        this.cities = [].concat.apply([this.firstValue], response.data.data);
        this.loader = false;
        if (response.data.data.length < 1) {
          this.empty = true;
        } else {
          this.empty = false;
        }
      } catch {
        console.log("Ocorreu um erro inesperado.");
      }
    },

    searchChange() {
      this.getProperties();
    },

    stateChange: function() {
      const id = this.stateSelected.id;
      this.citySelected = this.cities[0];
      this.getCities(id);
      this.getProperties();
    },

    cityChange: function() {
      this.getProperties();
    },

    orderChange: function() {
      this.getProperties();
    },

    propertyTypeChange: function() {
      this.getProperties();
    }
  }
};
</script>

<style lang="scss" scoped>
@import "@/assets/css/select";

.properties-list {
  padding: 0 0 60px;
  margin-top: 64px;

  .loader {
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    min-height: 300px;
    margin: 100px 0;
  }

  .empty {
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    min-height: 300px;
    margin: 100px 0;
    text-align: center;

    p {
      max-width: 310px;
      margin: 0 auto;
    }

    img {
      margin-bottom: 29px;
    }
  }

  .properties-header {
    padding: 70px 0 0 0;

    .container {
      max-width: 1200px;

      h2 {
        color: var(--yellow-custom);
        font-weight: var(--weight-regular);
      }
    }
  }

  .properties-content {
    margin: 0 auto;
    display: flex;
    max-width: 1200px;
    position: relative;
  }

  .properties-filter {
    height: 510px;
    margin: 58px 40px 0 0;
    box-shadow: 0px 4px 20px rgba(219, 224, 230, 0.5);
    border-radius: 20px;
    padding: 20px;

    min-width: 304px;

    .container {
      display: block;
      align-items: center;
      padding-bottom: 10px;
    }

    label {
      font-size: var(--size-base);
      font-weight: var(--weight-bold);
    }

    .search {
      margin: 8px 0 20px 0;
      background: var(--grey-custom);
      max-width: 324px;
      width: 100%;
      border-radius: 6px 32px 32px 6px;
      display: flex;
      align-items: center;
      padding: 0 23px;
      height: 50px;
      position: relative;

      img {
        width: 24px;
        height: 24px;
        margin-right: 20px;
      }

      input {
        height: 24px;
        border: none;
        background: none;
        box-shadow: none;
        font-size: var(--size-button);
        font-weight: var(--weight-light);
        color: var(--grey-dark-custom);
        width: 100%;
        padding-right: 30px;
        max-width: 240px;
      }

      .button-primary {
        width: 50px;
        position: absolute;
        right: 0;
        min-width: 65px;
        border-radius: 10px;

        img {
          margin: 0 0 0 0px;
        }
      }
    }

    .select {
      width: 100%;
      margin: 8px 0 20px 0;
      font-size: var(--size-button);
      font-weight: var(--weight-light);
      color: var(--grey-dark-custom);
      border-radius: 6px;
      border: 1px solid var(--border-select);
      height: 50px;
      padding: 0 1.8em 0 16px;
      background-position: right 0.6em top 50%;
    }
  }

  .properties-section {
    padding: 0 0 40px 0;

    .container {
      display: flex;
      justify-content: space-between;
      max-width: 896px;
      align-items: center;

      &.container-properties {
        max-width: 896px;
        margin-top: 62px;
        flex: 1;
        flex-wrap: wrap;
        justify-content: flex-start;
      }
    }

    .view-more {
      margin: 60px 0 0;
      text-align: center;

      a {
        outline: none;
        text-decoration: none;
        font-weight: var(--weight-bold);
        color: var(--blue-custom);
        cursor: pointer;
      }
    }

    .box-properties {
      position: relative;
      min-height: 358px;
      display: flex;
      max-width: 250px;
      width: 100%;
      margin: 0 10px 39px 10px;

      &:nth-child(3n) {
        margin-right: 0;
      }

      .properties-image {
        position: absolute;
        top: 0;
        left: 0;
        border-radius: 20px;
        height: 210px;
        width: 100%;
        object-fit: cover;
      }

      a {
        text-decoration: none;
        width: 100%;
      }

      .properties-content {
        position: relative;
        z-index: 5;
        display: flex;
        height: 370px;
        width: 100%;
        flex-direction: column;
        justify-content: space-between;
        padding: 24px 16px 16px;
        border-radius: 20px;

        .tag {
          background: rgba(183, 145, 105, 1);
          color: var(--white);
          font-size: var(--size-tag);
          display: flex;
          align-items: center;
          height: 25px;
          max-width: 117px;
          padding: 1px 0 0;
          border-radius: 39px;
          justify-content: center;
          font-weight: 700;
        }

        .logo {
          width: 66px;
          height: auto;
          margin-bottom: 12px;
          background-color: var(--white);
          border-radius: 10px;
        }

        a {
          color: var(--white);
          text-decoration: none;
          width: 100%;
        }

        h3 {
          font-weight: 700;
          line-height: 24px;
          color: var(--blue-custom);
          font-size: var(--size-large);
          margin-bottom: 4px;
          min-height: 48px;
        }

        .locale {
          max-width: 218px;
          min-height: 38px;
          font-weight: 400;
          color: var(--blue-custom);
          line-height: 19px;
          font-size: var(--size-button);
          margin-bottom: 12px;
          overflow: hidden;
          display: -webkit-box;
          -webkit-line-clamp: 2;
          -webkit-box-orient: vertical;
        }

        .infos {
          font-weight: 400;
          color: var(--yellow-custom);
          line-height: 14px;
          font-size: var(--size-small);
          text-transform: uppercase;
          display: inline-block;
          margin-right: 16px;
          position: relative;

          &::after {
            content: "";
            position: absolute;
            right: -10px;
            top: 4px;
            background: var(--yellow-custom);
            width: 5px;
            height: 5px;
            border-radius: 100px;
          }
          &:last-child {
            margin-right: 0px;

            &::after {
              display: none;
            }
          }
        }
      }
    }
  }

  @media (max-width: 1366px) {
    .properties-section .box-properties {
      margin-right: 15px;
    }
  }

  @media (max-width: 768px) {
    margin-top: 0px;

    .properties-header {
      margin-top: 60px;

      h2 {
        font-size: var(--size-h4);
      }

      ul {
        li {
          font-size: var(--size-regular);
        }
      }
    }

    .properties-content {
      margin: 0 auto;
      display: block;
      position: relative;
    }

    .properties-filter {
      margin: 28px;
      width: 84%;

      max-height: 430px;

      .container {
        align-items: flex-start;
        flex-direction: column;

        .search {
          margin: 0 0 12px;
          max-width: 100%;
        }

        .select {
          width: 100%;
          margin: 0 0 12px;
          max-width: 100%;
        }
      }
    }

    .properties-section {
      padding: 0 0;

      .container {
        align-items: flex-start;
        flex-direction: column;

        &.container-properties {
          flex: 1;
          flex-wrap: wrap;
          align-items: center;
          flex-direction: row;
          margin-top: 32px;
        }
      }

      .box-properties {
        min-height: inherit;
        margin-bottom: 20px;
        max-width: 100%;

        .properties-image {
          width: 100%;
        }
      }
    }
  }

  @media (max-width: 350px) {
    .container.container-properties {
      .box-properties {
        .properties-content {
          width: 100%;
          height: 345px;
        }
        .properties-image {
          height: 200px;
        }
      }
    }
  }
}
</style>
